var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, QueryList } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { EditService } from 'app/services/edit.service';
import { MainDataService } from 'app/services/main-data.service';
import { ResolutionCenterService } from 'app/services/resolution-center.service';
import { ResolutionQcService } from 'app/services/resolution-qc.service';
import { ResolutionAOEComponent } from '../resolution-aoe/resolution-aoe.component';
import { ResolutionASQComponent } from '../resolution-asq/resolution-asq.component';
import { ResolutionCADComponent } from '../resolution-cad/resolution-cad.component';
import { ResolutionDAVComponent } from '../resolution-dav/resolution-dav.component';
var ResolutionInspectorComponent = /** @class */ (function () {
    function ResolutionInspectorComponent(activityService, attrIndexService, commonService, editService, mainDataService, resoCenterService, resoQcService) {
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.editService = editService;
        this.mainDataService = mainDataService;
        this.resoCenterService = resoCenterService;
        this.resoQcService = resoQcService;
        this.qaResolverFeeds = [];
    }
    ResolutionInspectorComponent.prototype.discard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmDiscard, geomChangedIds, recordsIndex, resoFeed, newDataRecord;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.editService.warnOnDiscard()];
                    case 1:
                        confirmDiscard = _a.sent();
                        if (!confirmDiscard) {
                            return [2 /*return*/];
                        }
                        geomChangedIds = [];
                        recordsIndex = this.resoCenterService.getRecordsIndex();
                        Object.keys(recordsIndex).forEach(function (id) {
                            if (recordsIndex[id].changedCols.indexOf(_this.attrIndexService.geomColManual) > -1) {
                                geomChangedIds.push(id);
                            }
                        });
                        if (geomChangedIds.length > 0) {
                            this.activityService.resetFeatures.next({
                                ids: geomChangedIds
                            });
                        }
                        // restore attrs // TODO
                        Object.keys(recordsIndex).forEach(function (id) {
                            var rec = recordsIndex[id];
                            if (rec.changedCols.length) {
                                rec.changedCols.splice(0, rec.geomLength);
                                Object.keys(rec.props).forEach(function (k) { return rec.props[k] = rec.originalProps[k]; });
                                // rec.changedCols = [];
                                // rec.props = JSON.parse(JSON.stringify(rec.originalProps));
                            }
                        });
                        resoFeed = this.resoCenterService.resoFeedBS.getValue();
                        if (!resoFeed || !resoFeed.record || !resoFeed.feeds) {
                            this.clearAllFeeds();
                            return [2 /*return*/];
                        }
                        // const original = resoFeed.record[this.attrIndexService.originalDataKey];
                        // const newDataRecord = JSON.parse(JSON.stringify(original));
                        // newDataRecord[this.attrIndexService.originalDataKey] = original;
                        this.mainDataService.clearDataChangeInIndex(resoFeed.recordId);
                        newDataRecord = this.mainDataService.getDataAttrs(resoFeed.recordId);
                        this.resoCenterService.resoFeedBS.next({
                            record: newDataRecord,
                            feeds: resoFeed.feeds,
                            recordId: resoFeed.recordId
                        });
                        this.updateCode();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResolutionInspectorComponent.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.resoCenterService.commit()];
                    case 2:
                        _a.sent();
                        this.resoCenterService.setRecordsIndex({});
                        this.hasDataChange = false;
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResolutionInspectorComponent.prototype.checkCommitable = function () {
        this.hasDataChange = this.hasChanged();
        return this.hasDataChange;
    };
    ResolutionInspectorComponent.prototype.onEdit = function () {
        this.updateCode();
    };
    ResolutionInspectorComponent.prototype.updateCode = function () {
        var _this = this;
        if (this.aoeTemplate) {
            this.aoeTemplate.rules.forEach(function (rule) {
                switch (rule.code) {
                    case 'ADN':
                        var recordInfo = _this.resoCenterService.getRecordInfo(_this.aoeTemplate.centerline.id);
                        var geomLength = recordInfo.geomLength;
                        rule.isFixed = !_this.resoQcService.checkADN(_this.aoeTemplate.centerline.props, geomLength);
                        break;
                    case 'AOE':
                        rule.isFixed = !_this.resoQcService.checkAOE(_this.aoeTemplate.centerline.props);
                        break;
                    case 'ARG':
                        rule.isFixed = !_this.resoQcService.checkARG(_this.aoeTemplate.centerline.props);
                        break;
                    case 'ADR':
                        rule.isFixed = !_this.resoQcService.checkADR(_this.aoeTemplate.centerline.props);
                        break;
                    case 'RDR':
                        rule.isFixed = _this.aoeTemplate.isFlipRoadGeom;
                        break;
                }
            });
        }
        if (this.asqTemplate) {
            this.asqTemplate.rules.forEach(function (rule) {
                switch (rule.code) {
                    case 'ASQ':
                        var recordPropsList = _this.asqTemplate.addrList.map(function (i) { return i.props; });
                        rule.isFixed = !_this.resoQcService.checkASQ(recordPropsList);
                        break;
                }
            });
        }
        if (this.davTemplate) {
            this.davTemplate.rules.forEach(function (rule) {
                switch (rule.code) {
                    case 'DAV':
                    case 'DAVL':
                        var recordPropsList = _this.davTemplate.addrList.map(function (i) { return i.props; });
                        var cols = _this.davTemplate.cols.map(function (c) { return c.prop; });
                        rule.isFixed = !_this.resoQcService.checkDAV(recordPropsList, cols);
                        break;
                }
            });
        }
        if (this.raoTemplates) {
            this.raoTemplates.toArray().forEach(function (raoComponent) {
                raoComponent.rules.forEach(function (rule) {
                    switch (rule.code) {
                        case 'RAO':
                        case 'RAOL':
                            raoComponent.updateRAO();
                            // rule.isFixed = !this.resoQcService.checkRAO(this.raoTemplate.centerlineList[0].props, this.raoTemplate.centerlineList[1].props);
                            rule.isFixed = !raoComponent.centerlineList.find(function (i) { return i.isFromLeftError || i.isFromRightError || i.isToLeftError || i.isToRightError; });
                            break;
                    }
                });
            });
        }
    };
    ResolutionInspectorComponent.prototype.hasChanged = function () {
        var _this = this;
        var recordsIndex = this.resoCenterService.getRecordsIndex();
        var changed = Object.keys(recordsIndex).find(function (id) { return !!_this.resoCenterService.getRecordInfo(id).changedCols.length; });
        if (changed) {
            return true;
        }
        return false;
    };
    ResolutionInspectorComponent.prototype.clearAllFeeds = function () {
        this.aoeFeed = null;
        this.asqFeed = null;
        this.davFeed = null;
        this.raoFeeds = null;
        // this.raoFeed = null;
    };
    ResolutionInspectorComponent.prototype.onFeedChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var idsByCate, _i, _a, cateCode;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // Clear stored records
                        this.resoCenterService.setRecordsIndex({});
                        idsByCate = {};
                        this.qaResolverFeeds.forEach(function (i) {
                            Object.keys(i.feed).forEach(function (cateCode) {
                                if (!idsByCate[cateCode]) {
                                    idsByCate[cateCode] = [];
                                }
                                if (idsByCate[cateCode].indexOf(i.feed[cateCode].id) === -1) {
                                    idsByCate[cateCode].push(i.feed[cateCode].id);
                                }
                                if (i.feed[cateCode].list) {
                                    i.feed[cateCode].list.forEach(function (id) {
                                        if (idsByCate[cateCode].indexOf(id) === -1) {
                                            idsByCate[cateCode].push(id);
                                        }
                                    });
                                }
                            });
                        });
                        _i = 0, _a = Object.keys(idsByCate);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        cateCode = _a[_i];
                        if (!idsByCate[cateCode].length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.resoCenterService.getRecordsDetails(cateCode, idsByCate[cateCode])];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.clearAllFeeds();
                        this.qaResolverFeeds.forEach(function (i) {
                            if (i.rules.find(function (cd) { return ['AOE', 'ADN', 'ARG', 'ADR', 'RDR'].indexOf(cd) > -1; })) {
                                _this.aoeFeed = i;
                            }
                            else if (i.rules.find(function (cd) { return ['ASQ'].indexOf(cd) > -1; })) {
                                _this.asqFeed = i;
                            }
                            else if (i.rules.find(function (cd) { return ['DAV', 'DAVL'].indexOf(cd) > -1; })) {
                                _this.davFeed = i;
                            }
                            else if (i.rules.find(function (cd) { return ['RAO', 'RAOL'].indexOf(cd) > -1; })) {
                                if (!_this.raoFeeds) {
                                    _this.raoFeeds = [];
                                }
                                _this.raoFeeds.push(i);
                                // this.raoFeed = i;
                            }
                            else if (i.rules.find(function (cd) { return ['CAD'].indexOf(cd) > -1; })) {
                                _this.cadFeed = i;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ResolutionInspectorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.resoFeedSub = this.resoCenterService.resoFeedBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data || !data.record || !data.feeds) {
                            this.clearAllFeeds();
                            return [2 /*return*/];
                        }
                        this.recordRaw = data.record;
                        this.qaResolverFeeds = data.feeds;
                        return [4 /*yield*/, this.onFeedChange()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ResolutionInspectorComponent.prototype.ngOnDestroy = function () {
        this.resoFeedSub.unsubscribe();
    };
    return ResolutionInspectorComponent;
}());
export { ResolutionInspectorComponent };
